import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";
import ListOrders from "./pages/General/AllOrders";
import DetailsOrder from "./pages/General/DetailsProduct";
import HomBannerChanges from "./pages/website-changes/HomBannerChanges";
import CategoryChanges from "./pages/website-changes/CategoryChanges";
import TopSellingProductsBanner from "./pages/website-changes/TopSellingProductsBanner";
import TopFeaturedProductsRollingText from "./pages/website-changes/TopFeaturedProductsRollingText";
import SponsorPage from "./pages/website-changes/SponsorPage";
import ChangesInWebsite from "./pages/website-changes/ChangesInWebsite";
import Users from "./pages/General/Users";

const App = () => {
  const [selectedItem, setSelectedItem] = useState("Dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === "admin" && password === "admin") {
      setIsAuthenticated(true);
      localStorage.setItem("isAuthenticated", "true");
      setError("");
      navigate("/");
    } else {
      setError("Invalid credentials");
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
    setUsername("");
    setPassword("");
    navigate("/login");
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    if (sidebarOpen) setSidebarOpen(false);
  };

  const handleToggleSidebar = () => setSidebarOpen((prev) => !prev);

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-96">
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Admin Login</h2>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {sidebarOpen && <div onClick={handleToggleSidebar} className="fixed inset-0 bg-black opacity-50 md:hidden z-20" />}
      <div className={`fixed inset-y-0 left-0 transform ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 transition-transform duration-300 ease-in-out z-30 md:static md:flex md:w-64`}>
        <Sidebar onSelect={handleSelectItem} sidebarOpen={sidebarOpen} toggleSidebar={handleToggleSidebar} onLogout={handleLogout} />
      </div>
      {isMobile && (
        <div className="md:hidden fixed top-0 left-0 right-0 z-20 bg-white shadow-md p-4 flex justify-between items-center">
          <button onClick={handleToggleSidebar} className="text-gray-700 hover:text-gray-500 transition-colors">☰</button>
          {sidebarOpen && <button onClick={handleToggleSidebar} className="text-gray-700 hover:text-gray-500 transition-colors">✕</button>}
        </div>
      )}
      <div className={`flex-1 bg-gray-50 transition-all duration-300 ease-in-out ${sidebarOpen ? "opacity-50 pointer-events-none md:opacity-100" : ""}`}>
        <Routes>
          <Route path="/login" element={<Navigate to="/" />} />
          <Route path="/" element={<MainContent selectedItem={selectedItem} />} />
          <Route path="/admin/orders" element={<ListOrders />} />
          <Route path="/admin/DetailsOrder/:id" element={<DetailsOrder />} />
          <Route path="/admin/HomBannerChanges" element={<HomBannerChanges />} />
          <Route path="/admin/CategoryChanges" element={<CategoryChanges />} />
          <Route path="/admin/TopSellingProductsBanner" element={<TopSellingProductsBanner />} />
          <Route path="/admin/TopFeaturedProductsRollingText" element={<TopFeaturedProductsRollingText />} />
          <Route path="/admin/SponsorPage" element={<SponsorPage />} />
          <Route path="/admin/ChagesInWebsite" element={<ChangesInWebsite />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
